export default __webpack_public_path__ + "static/media/9.e81311b1.jpg";